import Twine from 'twine'
import $ from 'domtastic'
import axios from 'axios'
import queryString from 'query-string'
import RangeInput from './range-input'
import { isAuthenticated } from './auth'
import {
  disableCreatePreference,
  enableCreatePreference,
  createPreference,
  fetchPreferences,
  deletePreference,
} from './preferences'
import { trackGtmTenantSearch } from './analytics'

class Filters {
  constructor() {
    this.initialFilterValues = {
      location: '',
      minprice: '',
      maxprice: '',
      propertytypes: [], // Available types: house, apartment, condo-and-multiplex, townhome, in-law-and-basement, single-room, sublease-and-student-contract
      aresmalldogsallowed: false,
      arelargedogsallowed: false,
      arecatsallowed: false,
      issmokingallowed: null,
      minbedrooms: null,
      maxbedrooms: null,
      minbathrooms: null,
      maxbathrooms: null,
      amenities: [],
      listingids: [],
      isacceptingapplications: false,
      minsquarefootage: '',
      minacres: '',
      minyearbuilt: '',
      maxyearbuilt: '',
      minlease: '',
      maxlease: '',
      keywords: '',
      myplaces: false,
      savedsearches: false,
      orderby: 'DateDescending',
      page: 1,
    }
    this.lastAPIData = null

    const queryparams =
      window.location.search != ''
        ? queryString.parseUrl(window.location.href, { arrayFormat: 'none' })
            .query
        : {}

    // Ensure single value url params are converted to arrays
    const ensureArrayValues = (propNames, dest) =>
      propNames.forEach((prop) => {
        if (
          Object.keys(dest).indexOf(prop) !== -1 &&
          !Array.isArray(dest[prop])
        ) {
          dest[prop] = [dest[prop]]
        }
      })
    ensureArrayValues(['propertytypes', 'amenities', 'listingids'], queryparams)

    // Parse queryparam values to correct types
    const parseValues = (propNames, dest) =>
      propNames.forEach((prop) => {
        if (
          Object.keys(dest).indexOf(prop) !== -1 &&
          typeof dest[prop] === 'string' &&
          dest[prop].length
        ) {
          dest[prop] = JSON.parse(dest[prop])
        }
      })
    parseValues(
      [
        'arecatsallowed',
        'arelargedogsallowed',
        'aresmalldogsallowed',
        'isacceptingapplications',
        'issmokingallowed',
        'minbedrooms',
        'maxbedrooms',
        'minbathrooms',
        'maxbathrooms',
        'minlease',
        'maxlease',
        'minprice',
        'maxprice',
        'minyearbuilt',
        'maxyearbuilt',
        'minacres',
        'minsquarefootage',
      ],
      queryparams
    )

    this.filterValues = Object.assign(
      {},
      {
        ...this.initialFilterValues,
        ...queryparams,
      }
    )
    this.lastFilterValues = { ...this.filterValues }

    const initialLocation = document
      .getElementById('geocoder')
      .getAttribute('data-location')
    if (initialLocation) {
      this.filterValues.location = initialLocation
    }

    window.initialFilterValues = this.initialFilterValues

    this.filterValues.changeMinPrice = (price) => {
      this.filterValues.minprice = price
      this.searchFilters()
    }

    this.filterValues.changeMaxPrice = (price) => {
      this.filterValues.maxprice = price
      this.searchFilters()
    }

    this.filterValues.toggleMyPlaces = () => {
      if (!this.filterValues.myplaces) {
        this.filterValues.resetFilters()

        this.filterValues.myplaces = true
        this.disableFilters()
        if (window.MapUtilty) window.MapUtilty.clearLocation()
        Twine.reset(this.filterValues).bind().refresh()
        this.searchFilters()

        return
      }

      this.filterValues.resetFilters()
      this.filterValues.myplaces = false
      this.searchFilters()
      this.enableFilters()
      return
    }

    this.filterValues.toggleSaved = () => {
      this.enableFilters()

      if (!this.filterValues.savedsearches) {
        this.filterValues.resetFilters()

        this.filterValues.savedsearches = true
        if (window.MapUtilty) window.MapUtilty.clearLocation()
        Twine.reset(this.filterValues).bind().refresh()
        this.fetchSavedSearches()
        return
      }

      this.filterValues.resetFilters()
      this.filterValues.savedsearches = false
      this.searchFilters()
      $('.search-listing').attr('data-my-places', false)
    }

    this.filterValues.changePropertyType = (node, event) => {
      if (event.target.checked) {
        this.filterValues.propertytypes.push(
          event.target.getAttribute('data-el-value')
        )
      } else {
        this.filterValues.propertytypes =
          this.filterValues.propertytypes.filter(
            (item) => item !== event.target.getAttribute('data-el-value')
          )
      }
    }

    this.filterValues.changeAmenities = (node, event) => {
      if (event.target.checked) {
        this.filterValues.amenities.push(
          event.target.getAttribute('data-el-value')
        )
      } else {
        this.filterValues.amenities = this.filterValues.amenities.filter(
          (item) => item !== event.target.getAttribute('data-el-value')
        )
      }
    }

    this.filterValues.resetFilters = (type) => {
      const initialState = {
        location: 'Salt Lake City, UT',
        bounds: [],
        maxprice: '',
        minprice: '',
        propertytypes: [], // Available types: house, apartment, condo-and-multiplex, townhome, in-law-and-basement, single-room, sublease-and-student-contract
        aresmalldogsallowed: false,
        arelargedogsallowed: false,
        arecatsallowed: false,
        issmokingallowed: null,
        minbedrooms: null,
        maxbedrooms: null,
        minbathrooms: null,
        maxbathrooms: null,
        amenities: [],
        isacceptingapplications: false,
        minsquarefootage: '',
        minacres: '',
        minyearbuilt: '',
        maxyearbuilt: '',
        minlease: '',
        maxlease: '',
        keywords: '',
        myplaces: false,
        orderby: 'DateDescending',
        page: 1,
      }

      if (type) {
        if (Array.isArray(type)) {
          type.map((key) => {
            this.filterValues[key] = initialState[key]
            return key
          })

          return
        }

        this.filterValues[type] = initialState[type]
      } else {
        this.filterValues = {
          ...this.filterValues,
          ...initialState,
        }
      }

      Twine.reset(this.filterValues).bind().refresh()
    }

    this.filterValues.onMinBlur = (node, event) => {
      if (
        this.filterValues.maxprice != '' &&
        Number(this.filterValues.maxprice) < Number(node.value)
      ) {
        this.filterValues.minprice = ''
      } else if (
        this.lastFilterValues.minprice !== this.filterValues.minprice
      ) {
        this.searchFilters()
      }
    }

    this.filterValues.onMaxBlur = (node, event) => {
      if (
        this.filterValues.minprice != '' &&
        Number(this.filterValues.minprice) > Number(node.value)
      ) {
        this.filterValues.maxprice = ''
      } else if (
        this.lastFilterValues.maxprice !== this.filterValues.maxprice
      ) {
        this.searchFilters()
      }
    }

    this.filterValues.changeMinBedroom = (node) => {
      if (node.checked) {
        if (
          this.filterValues.minbedrooms == null &&
          this.filterValues.maxbedrooms == null &&
          node.value < 5
        ) {
          this.filterValues.maxbedrooms = node.value
        }

        if (this.filterValues.minbedrooms == null) {
          this.filterValues.minbedrooms = node.value
          return
        }

        if (
          !!this.filterValues.minbedrooms &&
          this.filterValues.maxbedrooms == null
        ) {
          if (this.filterValues.minbedrooms > node.value) {
            let start = this.filterValues.minbedrooms

            this.filterValues.maxbedrooms = start
            this.filterValues.minbedrooms = node.value

            return
          }

          this.filterValues.maxbedrooms = node.value

          return
        }

        if (
          !!this.filterValues.minbedrooms &&
          !!this.filterValues.maxbedrooms
        ) {
          if (node.value > this.filterValues.maxbedrooms) {
            this.filterValues.maxbedrooms = node.value
          }

          if (node.value < this.filterValues.minbedrooms) {
            this.filterValues.minbedrooms = node.value
          }

          if (
            node.value > this.filterValues.minbedrooms &&
            node.value < this.filterValues.maxbedrooms
          ) {
            this.filterValues.maxbedrooms = node.value
          }

          return
        }
      }

      if (!node.checked) {
        this.filterValues.minbedrooms = null
        this.filterValues.maxbedrooms = null
      }
    }
    this.filterValues.changeMinBathroom = (node) => {
      if (node.checked) {
        if (
          this.filterValues.minbathrooms == null &&
          this.filterValues.maxbathrooms == null &&
          node.value < 5
        ) {
          this.filterValues.maxbathrooms = node.value
        }

        if (this.filterValues.minbathrooms == null) {
          this.filterValues.minbathrooms = node.value
          return
        }

        if (
          !!this.filterValues.minbathrooms &&
          this.filterValues.maxbathrooms == null
        ) {
          if (this.filterValues.minbathrooms > node.value) {
            let start = this.filterValues.minbathrooms

            this.filterValues.maxbathrooms = start
            this.filterValues.minbathrooms = node.value

            return
          }

          this.filterValues.maxbathrooms = node.value

          return
        }

        if (
          !!this.filterValues.minbathrooms &&
          !!this.filterValues.maxbathrooms
        ) {
          if (node.value > this.filterValues.maxbathrooms) {
            this.filterValues.maxbathrooms = node.value
          }

          if (node.value < this.filterValues.minbathrooms) {
            this.filterValues.minbathrooms = node.value
          }

          if (
            node.value > this.filterValues.minbathrooms &&
            node.value < this.filterValues.maxbathrooms
          ) {
            this.filterValues.maxbathrooms = node.value
          }
          return
        }
      }

      if (!node.checked) {
        this.filterValues.minbathrooms = null
        this.filterValues.maxbathrooms = null
      }
    }

    this.filterValues.formatBeds = (minBeds, maxBeds) => {
      let result = 'Bed'

      if ((minBeds && minBeds === maxBeds) || minBeds == 5) {
        result += `(${minBeds})`
      } else if (maxBeds > minBeds) {
        result += `(${minBeds}-${maxBeds})`
      }

      result = result.replace('0', 'S').replace('5', '5+')

      return result
    }

    this.filterValues.formatBaths = (minBaths, maxBaths) => {
      let result = 'Bath'

      if ((minBaths && minBaths === maxBaths) || minBaths == 5) {
        result += `(${minBaths})`
      } else if (maxBaths > minBaths) {
        result += `(${minBaths}-${maxBaths})`
      }

      result = result.replace('5', '5+')

      return result
    }

    this.filterValues.formatLease = (lease) => {
      switch (+lease) {
        case -1:
          return 'Month-to-Month'
        case 1:
          return '1 Month'
        case 2:
          return '2 Months'
        case 3:
          return '3 Months'
        case 4:
          return '4 Months'
        case 5:
          return '5 Months'
        case 6:
          return '6 Months'
        case 9:
          return '9 Months'
        case 12:
          return '1 Year'
        case 18:
          return '1½ Years'
        case 24:
          return '2 Years'
        default:
          return ''
      }
    }

    this.filterValues.formatMoreFilters = () => {
      const advanced = {
        aresmalldogsallowed: false,
        arelargedogsallowed: false,
        arecatsallowed: false,
        issmokingallowed: null,
        amenities: [],
        isacceptingapplications: false,
        minsquarefootage: '',
        minacres: '',
        minyearbuilt: '',
        maxyearbuilt: '',
        minlease: '',
        maxlease: '',
        keywords: '',
      }

      if (document.getElementById('property-fake').offsetParent === null) {
        advanced.propertytypes = []
      }
      if (document.getElementById('bed-fake').offsetParent === null) {
        advanced.minbedrooms = null
      }
      if (document.getElementById('bath-fake').offsetParent === null) {
        advanced.minbathrooms = null
      }

      const delta = []
      Object.keys(advanced).map((x) => {
        this.filterValues[x] !== advanced[x] &&
          (Array.isArray(this.filterValues[x])
            ? this.filterValues[x].length > 0 &&
              this.filterValues[x].forEach((y) => delta.push(y))
            : delta.push(x))
      })

      return delta.length ? `More Filters(${delta.length})` : 'More Filters'
    }

    this.filterValues.onSortingChange = (node) => {
      this.searchFilters()
    }

    this.filterValues.createPreference = () =>
      createPreference(this.getParams())

    this.filterValues.searchFilters = this.searchFilters.bind(this)
    this.filterValues.fetchMapItems = this.fetchMapItems.bind(this)

    Twine.reset(this.filterValues).bind().refresh()

    window.filterValues = this.filterValues

    this.initializeFilters()
    this.listenStepEvents()
  }

  initializeFilters() {
    const minMaxRange = new RangeInput('#min-max-price')
    new RangeInput('#min-max-price2')
    new RangeInput('#lease-length')

    if ($('.more-filters-button')) {
      $('.more-filters-button').on('click', () => {
        $('.filters-modal-wrapper').addClass('open')
      })

      $('.filters-modal-wrapper .close-icon').on('click', () => {
        $('.filters-modal-wrapper').removeClass('open')
      })

      $(document).on('mouseup', function (e) {
        let container = $('.modal-inside')

        if (
          container[0] !== e.target &&
          container.find('*').filter((c) => c == e.target).length === 0
        ) {
          $('.filters-modal-wrapper').removeClass('open')
        }
      })
    }

    if (this.filterValues.myplaces) {
      disableCreatePreference()
      this.disableFilters()
    }
  }

  disableFilters() {
    $('.module.filters').addClass('disabled')
    $('.module.filters').find('input').attr('disabled', 'disabled')
    $('.module.filters').find('.fake-selectbox').addClass('disabled')
  }

  enableFilters() {
    $('.module.filters').removeClass('disabled')
    $('.module.filters').find('input').removeAttr('disabled')
    $('.module.filters').find('.fake-selectbox').removeClass('disabled')
  }

  listenStepEvents() {
    $('.pagination .next-page').on('click', (e) => {
      e.preventDefault()

      this.filterValues.page++
      const params = this.getParams()

      this.fetchSidebarItems(params)
    })

    $('.pagination .previous-page').on('click', (e) => {
      e.preventDefault()

      this.filterValues.page--
      const params = this.getParams()

      this.fetchSidebarItems(params)
    })
  }

  fetchFavorites(params) {
    if (!isAuthenticated()) {
      $('.search-listing').attr('data-has-results', false)
      $('.search-listing').attr('data-my-places', true)
      $('.search-listing .search-results-title').text('My Places')
      $('.search-listing .search-result-text').text('No Results')
      return
    }

    $('.search-listing .loading').addClass('show')
    document.querySelector('.search-listing').scrollTop = 0

    const qs = queryString.stringify(params, { arrayFormat: 'none' })
    const searchUri = `${rentler.apiBaseUri}/favorites/search`

    axios.get(`${searchUri}?${qs}`).then((data) => {
      this.renderSidebarItems(data.data)
      const favorites = data.data.listings.map((m) => m.listingId).join(',')
      $('[data-favorites]').attr('data-favorites', favorites)
      window.history.replaceState(null, null, data.data.url)
    })
  }

  fetchFavoritesMapItems() {
    let params = this.getParams()
    const qs = queryString.stringify(params, { arrayFormat: 'none' })
    const searchUri = `${rentler.apiBaseUri}/favorites/searchmap`

    axios.get(`${searchUri}?${qs}`).then((data) => {
      if (window.MapUtilty) {
        window.MapUtilty.updateMapMarkers(data.data)
        window.MapUtilty.fitMapMarkerBounds(data.data)
      }
    })
  }

  fetchSidebarItems(params) {
    $('.search-listing .loading').addClass('show')
    document.querySelector('.search-listing').scrollTop = 0

    const qs = queryString.stringify(params, { arrayFormat: 'none' })
    const searchUri = `${rentler.apiBaseUri}/search`

    axios.get(`${searchUri}?${qs}`).then((data) => {
      this.lastAPIData = data.data
      if (window.MapUtilty && !window.MapUtilty.getLocation()) {
        window.MapUtilty.setLocation(data.data.location)
      }
      this.renderSidebarItems(data.data)
      window.history.replaceState(null, null, data.data.url)
    })
  }

  fetchMapItems() {
    let params = this.getParams()

    if (
      window.rentlerMap &&
      !params.location &&
      !this.filterValues.savedsearches
    ) {
      params.bounds = window.rentlerMap.getBounds().toArray().flat()
    }

    const qs = queryString.stringify(params, { arrayFormat: 'none' })
    const searchUri = `${rentler.apiBaseUri}/searchmap`
    axios.get(`${searchUri}?${qs}`).then((data) => {
      if (window.MapUtilty) {
        const favorites = $('[data-favorites]')
          .attr('data-favorites')
          .split(',')
        data.data.features.forEach((f) => {
          const ids = f.properties.ids ? f.properties.ids.split(',') : []
          const liked =
            favorites.includes(`${f.properties.id}`) ||
            favorites.some((x) => ids.includes(x))
          f.properties.liked = liked
        })
        window.MapUtilty.updateMapMarkers(data.data)
        if (this.filterValues.savedsearches) {
          window.MapUtilty.fitBounds(params.bounds)
        }
      }
    })
  }

  getParams() {
    let params = {}

    for (const property in this.filterValues) {
      if (typeof this.filterValues[property] != 'function') {
        if (
          Array.isArray(this.filterValues[property]) &&
          this.filterValues[property].length > 0
        ) {
          params[property] = this.filterValues[property]
        }

        if (this.filterValues[property] != this.initialFilterValues[property]) {
          params[property] = this.filterValues[property]
        }
      }
    }

    return params
  }

  fetchSavedSearches() {
    if (!isAuthenticated()) {
      $('.search-listing').attr('data-has-results', false)
      $('.search-listing').attr('data-saved-searches', true)
      $('.search-listing .search-results-title').text('Saved Search')
      $('.search-listing .search-result-text').text('No Results')
      return
    }

    const _this = this
    this.lastFilterValues = { ...this.filterValues }
    this.filterValues.page = 1

    fetchPreferences().then(success)

    function success(data) {
      _this.filterValues.bounds = data.bounds
      _this.fetchMapItems()
      _this.closeFilterModel()
    }
  }

  searchFilters(isMapSearch) {
    const _this = this

    if (!isMapSearch) {
      this.filterValues.savedsearches = false
    }

    this.lastFilterValues = { ...this.filterValues }
    this.filterValues.page = 1
    const params = this.getParams()

    Twine.reset(this.filterValues).bind().refresh()

    if (this.filterValues.myplaces) {
      // Disable create preference buttons when viewing my places list
      disableCreatePreference()

      this.fetchFavorites(params)
      this.fetchFavoritesMapItems()
    } else if (this.filterValues.savedsearches) {
      fetchPreferences().then(success)

      function success(data) {
        _this.filterValues.bounds = data.bounds
        _this.fetchMapItems()
      }
    } else {
      // Enable create preference buttons when executing a search
      enableCreatePreference()

      this.trackSearchFilters()
      this.fetchSidebarItems(params)
      this.fetchMapItems()
    }

    this.closeFilterModel()
  }

  closeFilterModel() {
    if ($('.selector-modal.open')) {
      $('.selector-modal.open').removeClass('open')
      $('.filter-overlay').removeClass('open')
    }

    if ($('.filters-modal-wrapper.open')) {
      $('.filters-modal-wrapper.open').removeClass('open')
    }

    if ($('.remove-after-search')) {
      $('.remove-after-search').remove()
    }
  }

  renderSidebarItems(data) {
    let itemsHtml = ''

    $('.search-listing').attr('data-has-results', data.hasResults)
    $('.search-listing').attr('data-my-places', data.myPlaces)
    $('.search-listing .search-results-title').text(`${data.uiResultsTitle}`)
    $('.search-listing .search-result-text').text(`${data.uiResultsSubtitle}`)
    $('.search-listing').attr('data-saved-searches', 'false')

    const favorites = $('[data-favorites]').attr('data-favorites').split(',')

    data.listings.map((listing) => {
      const isFavorite = favorites.includes(`${listing.listingId}`)
      itemsHtml += `
        <div class="col-12 col-lg-6">
          <div class="listing-item ${
            isFavorite ? 'liked' : ''
          }" data-liked="${isFavorite}" data-id="${listing.listingId}">
              <a href="${listing.url}" aria-label="${listing.uiAltText}">
                ${
                  listing.ribbonText
                    ? `<span class="tag" style="background-color: ${listing.ribbonColor}">${listing.ribbonText}</span>`
                    : ''
                }
                <div class="img-wrapper">
                  ${
                    listing.thumbnailUrls.length
                      ? `<img class="image lazyload" data-src="${listing.thumbnailUrls[0]}" data-sizes="auto" alt="${listing.uiAltText}" onerror="this.onerror=null; this.classList.add('image-error');" />`
                      : '<div class="image no-image"></div>'
                  }
                </div>
              </a>
              <a href="#" class="btn-favorite">
                  <div class="icon">
                      <span class="icon-heart-outline"></span>
                      <span class="icon-heart-fill"></span>
                  </div>
              </a>
              <a href="${listing.url}" aria-label="${listing.uiAltText}">
                  <div class="text">
                      <h3 class="price">${listing.uiPrice}</h3>
                      <div class="address">${listing.street}<br />${
        listing.uiCityState
      }</div>
                      <div class="bed-bath">
                          ${listing.uiBedrooms} • ${listing.uiBathrooms}<br />
                          ${listing.uiPropertyType}
                      </div>
                  </div>
              </a>
          </div>
        </div>
      `
    })

    $('.search-list-items').html(itemsHtml)

    $('.module.pagination').html(`
      <a href="${data.prevPageUrl}" class="previous-page ${data.uiPrevPageCSSClass}"><span class="icon-left"></span></a>
      <span class="text">${data.uiPagerSummary}</span>
      <a href="${data.nextPageUrl}" class="next-page ${data.uiNextPageCSSClass}"><span class="icon-right"></span></a>
    `)

    this.listenStepEvents()

    $('.search-listing .loading').removeClass('show')
  }

  trackSearchFilters() {
    // Build a search filters object for tracking each filter
    const filters = {
      bounds: this.filterValues.bounds,
      propertyTypes: this.filterValues.propertytypes.sort(),
      minPrice: +this.filterValues.minprice || undefined,
      maxPrice: +this.filterValues.maxprice || undefined,
      minBedrooms: +this.filterValues.minbedrooms || undefined,
      maxBedrooms: +this.filterValues.maxbedrooms || undefined,
      minBathrooms: +this.filterValues.minbathrooms || undefined,
      maxBathrooms: +this.filterValues.maxbathrooms || undefined,
      minLeaseLength: +this.filterValues.minlease || undefined,
      maxLeaseLength: +this.filterValues.maxlease || undefined,
      minAcres: +this.filterValues.minacres || undefined,
      minYearBuilt: +this.filterValues.minyearbuilt || undefined,
      maxYearBuilt: +this.filterValues.maxyearbuilt || undefined,
      minSquareFeet: +this.filterValues.minsquarefootage || undefined,
      isSmokingAllowed: this.filterValues.issmokingallowed,
      areSmallDogsAllowed: this.filterValues.aresmalldogsallowed,
      areLargeDogsAllowed: this.filterValues.arelargedogsallowed,
      areCatsAllowed: this.filterValues.arecatsallowed,
      isAcceptingApplications: this.filterValues.isacceptingapplications,
      keywords: this.filterValues.keywords,
      amenities: this.filterValues.amenities.sort(),
      location: this.filterValues.location,
    }

    // Remove any empty filters from the filters object
    const search = Object.fromEntries(
      Object.entries(filters).filter(([_, value]) => {
        if (Array.isArray(value)) {
          const result = !!value.length
          return result
        }

        const result =
          typeof value !== 'undefined' && value !== null && value !== ''
        return result
      })
    )

    // Track the search
    trackGtmTenantSearch({ search })
  }
}

export default Filters
